import { useContext, useCallback, useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { TransactionContext } from '../../../../../../app/contexts/TransactionContext'

export const useCustomerCardDetailsController = () => {
  const { id } = useParams()
  const [hasRun, setHasRun] = useState(false)
  const { transaction, setFilterParams } = useContext(TransactionContext)
  const { data: transactionData, isFetching, isLoading } = transaction

  const handleCustomerTransactionsById = useCallback(
    (id: string) => {
      setFilterParams({
        customerIds: id,
      })
    },
    [setFilterParams],
  )

  useEffect(() => {
    if (!hasRun) {
      handleCustomerTransactionsById(id ?? '')
      setHasRun(true)
    }
  }, [handleCustomerTransactionsById, hasRun, id])

  return {
    transactionData,
    isFetching,
    isLoading,
  }
}
